import axios from "axios"
import {getStationCode} from "../../network/NetworkUtil";
import {convertEpochMillisToLocalDateTime} from "../../util/Util";
import {
    logOperationalMetric, MetricType,
    STAGE_TAB_METRIC_KEY, RSWS_DWP_METADATA_METRIC,
    RSWS_DWP_UPLOAD_METRIC
} from "../../util/MetricUtil";
import {TIMEOUTS} from "../../util/Constants";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {Logger} from "../../util/Logger";

/** Upload DWP File **/
export function uploadDWPFile(data) {
    uploadDWPFileUtil(data)
}

/** Fetch DWP File Details **/
export function getDWPInfo(dispatcher, baseUrl, stationConfig) {
    getDWPFileInfoFromRSWS(dispatcher, baseUrl, stationConfig)
}

async function uploadDWPFileUtil(data) {
    const {dispatcher, baseUrl, file, alertDispatch, filterDispatcher, xptNodes, capability, routeDispatcher, stationConfig} = data;
    const startTime = Date.now();
    const stationCode = getStationCode();
    try {
        const formData = new FormData();
        formData.append("file", file, file.name)
        const config = {
            headers: {"Content-Type": "multipart/form-data"}
        }
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DWP_UPLOAD_API_TIMEOUT
        });
        const response = await api.post("/rsws/station/" + stationCode + "/uploadRoutes", formData, config);
        if (response.status === 200) {
            logOperationalMetric(startTime, stationCode, STAGE_TAB_METRIC_KEY, RSWS_DWP_UPLOAD_METRIC, MetricType.SUCCESS);
            alertDispatch({
                type: "SHOW_NOTIFICATION",
                data: {
                    alert: {title: "Upload Success", type: "success"}
                }
            });
            dispatcher({
                type: 'LOAD_DWP_INFO', data: {
                    baseUrl: baseUrl,
                    dispatcher: dispatcher,
                    stationConfig: stationConfig
                }
            });
            routeDispatcher({
                type: 'REFRESH_VIEW',
                data: {
                    dispatcher: routeDispatcher,
                    filterDispatcher: filterDispatcher,
                    baseUrl: baseUrl,
                    capability: capability,
                    xptNodes: xptNodes,
                    stationConfig: stationConfig
                }
            });
            return;
        }
    } catch (error) {
        Logger.error("Exception in DwpNetworkAPI.uploadDWPFileUtil", error);
    }
    logOperationalMetric(startTime, stationCode, STAGE_TAB_METRIC_KEY, RSWS_DWP_UPLOAD_METRIC, MetricType.FAILED);
    alertDispatch({
        type: "SHOW_NOTIFICATION",
        data: {
            alert: {title: "Upload Failed", type: "error"}
        }
    });
}

async function getDWPFileInfoFromRSWS(dispatcher, baseUrl, stationConfig) {
    const startTime = Date.now();
    const stationCode = getStationCode();
    try {
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DEFAULT_API_TIMEOUT
        });
        var response;
        if(stationConfig && stationConfig.authEnabled) {
            const requestPayload = {
                resourcePath: "/apigw/station/" + stationCode + "/dwpMetadata",
                httpMethod: "get",
                processName: "routeStaging"
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.get("/rsws/station/" + stationCode + "/dwpMetadata");
        }
        const output = response.data;
        logOperationalMetric(startTime, stationCode, STAGE_TAB_METRIC_KEY, RSWS_DWP_METADATA_METRIC, MetricType.SUCCESS);
        if (output.filename) dispatcher({type: "RECEIVE_DWP_INFO", data: convertDWPInfoResponse(output)});
    } catch (error) {
        Logger.error("Exception in DwpNetworkAPI.getDWPFileInfoFromRSWS", error);
        logOperationalMetric(startTime, stationCode, STAGE_TAB_METRIC_KEY, RSWS_DWP_METADATA_METRIC, MetricType.FAILED);
    }
}

function convertDWPInfoResponse(response) {
    return {
        fileName: response.filename,
        creationTime: convertEpochMillisToLocalDateTime(response.creationTime),
        uploadSource: response.uploadSource
    }
}



// WEBPACK FOOTER //
// ./src/components/fileupload/network/DwpNetworkAPI.js